class ReviewsTemplate extends HTMLElement {
    constructor() {
        super();
        window.addEventListener('load', () => {
            this.querySelectorAll('[open-reviews]').forEach((item) => {
                item.addEventListener('click', this.openReviews.bind(this));
            });
        });
    }

    openReviews() {
        looxWrite();
    }
}

customElements.define('reviews-template', ReviewsTemplate);